export const SELECT_ALL_VALUE = '__SELECT_ALL__';

export const TAG_TYPE_AWARENESS_BUNDLE = 'awareness_bundle';
export const TAG_TYPE_PASSPORT = 'passport';
export const TAG_TYPE_CONTENT_TAG = 'content_tag';

export const TAG_TYPE_OPTIONS = [
  {
    value: TAG_TYPE_AWARENESS_BUNDLE,
    label: 'Awareness bundle',
    description:
      'Use for existing tags that label awareness bundle content across destinations, hotels, and experiences.',
  },
  {
    value: TAG_TYPE_PASSPORT,
    label: 'Passport',
    description: 'Use for Experiences Passport tags. Only voucher-based experiences can be assigned.',
  },
  {
    value: TAG_TYPE_CONTENT_TAG,
    label: 'Content Tag',
    description: 'Use for permanent Experience content tags without schedules.',
  },
] as const;

export type TagTypeValue = (typeof TAG_TYPE_OPTIONS)[number]['value'];

export const isContentTag = (tagType: TagTypeValue): boolean => tagType === TAG_TYPE_CONTENT_TAG;
